import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../components/layout";
import SplittedScreen from "../../components/splittedScreen";
import InvitePageComponent from "../../components/invitePage";
import { Route, Routes } from "react-router-dom";

const InviteSplit = () => (
  <SplittedScreen>
    <InvitePageComponent />
  </SplittedScreen>
);

const InvitePage = () => (
  <main>
    <Helmet title="Invite" />
    <Layout>
      <Routes>
        <Route
          path=":operationId"
          element={<InviteSplit />}
        />
        <Route path="" element={<InviteSplit />} />
      </Routes>
    </Layout>
  </main>
);

export default InvitePage;
